export default __webpack_public_path__ + "static/media/icon-2.7efb9fe4.png";